import { FIELD_TYPES } from '../../../constants/fieldTypes';
import { BULK_ACTION_OPTIONS_VALUES } from '../../../constants/bulkActionOptions';
import { isEmpty } from '../../../utility/validation';

const JOB_TITLE_FIELDS = [
  {
    name: 'jobTitle',
    translationKey: 'jobTitle',
    type: FIELD_TYPES.SELECT,
    required: true,
    labelHelp: true,
    options: 'jobTitles',
    parser: {
      value: 'id',
      label: 'name',
    },
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
    ],
  },
];

const reportFields = [
  {
    name: 'reportTo',
    type: FIELD_TYPES.SELECT,
    translationKey: 'reportTo',
    options: 'managers',
    required: true,
    isReportTo: true,
    label: 'reportTo',
    labelHelp: true,
    shouldReturnOption: true,
    parser: {
      value: 'id',
      label: 'first_name',
    },
    isUser: true,
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
    ],
  },
];

const LEVEL_TRACK_FIELDS = [
  {
    name: 'framework',
    required: true,
    type: 'select',
    options: 'frameworks',
    translationKey: 'framework',
    labelHelp: true,
    dependants: [{ name: 'track', value: null }],
    parser: {
      value: 'id',
      label: 'name',
    },
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
    ],
  },
  {
    name: 'track',
    translationKey: 'track',
    type: 'select',
    labelHelp: true,
    options: 'tracks',
    parser: {
      value: 'id',
      label: 'name',
    },
    required: true,
    dependants: [
      {
        name: 'level',
        value: null,
      },
    ],
    parent: {
      name: 'framework',
      options: 'frameworks',
    },
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
    ],
  },
  {
    name: 'level',
    translationKey: 'level',
    type: 'select',
    labelHelp: true,
    required: true,
    options: 'levels',
    parser: {
      value: 'id',
      label: 'name',
    },
    parent: {
      name: 'track',
      options: 'tracks',
    },
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
    ],
  },
];

const DIVISION_DEPARTMENT_FIELDS = [
  {
    name: 'division',
    required: true,
    type: 'select',
    options: 'divisions',
    translationKey: 'division',
    labelHelp: true,
    dependants: [{ name: 'department', value: null }],
    parser: {
      value: 'id',
      label: 'name',
    },
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
    ],
  },
  {
    name: 'department',
    translationKey: 'department',
    type: 'select',
    labelHelp: true,
    options: 'departments',
    parser: {
      value: 'id',
      label: 'name',
    },
    required: true,
    parent: {
      name: 'division',
      options: 'divisions',
    },
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
    ],
  },
];

const APPLY_TAGS_FIELDS = [
  {
    name: 'tags',
    translationKey: 'tags',
    options: 'categories',
  },
];

export const fieldsToShow = {
  [BULK_ACTION_OPTIONS_VALUES.changeReportingTo]: reportFields,
  [BULK_ACTION_OPTIONS_VALUES.changeJobTitle]: JOB_TITLE_FIELDS,
  [BULK_ACTION_OPTIONS_VALUES.inviteUsers]: [],
  [BULK_ACTION_OPTIONS_VALUES.changeLevelTrack]: LEVEL_TRACK_FIELDS,
  [BULK_ACTION_OPTIONS_VALUES.changeDivisionDepartment]:
    DIVISION_DEPARTMENT_FIELDS,
  [BULK_ACTION_OPTIONS_VALUES.applyTags]: APPLY_TAGS_FIELDS,
};

export const prepareUsersToHandle = (users, idleUsers, isInvite) => {
  if (isInvite) return idleUsers;

  return users;
};
